<template>
    <div>
<!--        <div style="width: 100%;text-align: center;font-size: 16px;color: #1f1f24;background-color: #ffa500;line-height: 30px">-->
<!--            <span class="sampletext">샘플서버입니다!!! 절대 입금 하지마세요!!!</span>-->
<!--        </div>-->
        <div class="nav_title">
            <div class="name">

                <slot></slot>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "SubTitle"
    }
</script>

<style scoped>
    .nav_title {
        width: 100%;
        background-color: var(--subTitileBg);
        height:38px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        --border-radius: 5px;
        border-bottom: 1px solid #f9a818;
    }

    .name {
        width: 100%;
        color: #fff9ff !important;
        font-weight: 800;
        font-size: 12px;
        --border-bottom: 4px solid #c51a1b;
        line-height: 38px;
        box-sizing: border-box;
        padding: 0 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .name img {
        width: 32px;
        height: 32px;
        margin-left: 15px;
    }
</style>